var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlane(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 123,
    height: 123,
    viewBox: "0 0 123 123",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Iconly/Bulk/Send"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Send"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill 1",
    d: "M109.816 13.2138C107.253 10.5949 103.461 9.62628 99.9243 10.6513L17.463 34.4774C13.732 35.5126 11.0875 38.4698 10.3752 42.2213C9.6474 46.0445 12.1894 50.903 15.5104 52.9325L41.2943 68.6765C43.9388 70.296 47.3521 69.8911 49.5404 67.6976L79.0656 38.1725C80.5518 36.6299 83.0118 36.6299 84.4981 38.1725C85.9843 39.6536 85.9843 42.0675 84.4981 43.605L54.9217 73.1301C52.7282 75.3236 52.3182 78.7266 53.9326 81.3762L69.6868 107.257C71.5318 110.327 74.7093 112.075 78.1943 112.075C78.6043 112.075 79.0656 112.075 79.4756 112.019C83.4731 111.511 86.6506 108.79 87.8293 104.946L112.276 23.105C113.352 19.62 112.378 15.8275 109.816 13.2138",
    fill: "#4D70B3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Combined Shape",
    opacity: 0.4,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.4288 86.14C14.4448 86.14 13.4608 85.7659 12.7125 85.0125C11.2109 83.5109 11.2109 81.0816 12.7125 79.58L19.7081 72.5792C21.2098 71.0827 23.6441 71.0827 25.1458 72.5792C26.6423 74.0809 26.6423 76.5152 25.1458 78.0169L18.145 85.0125C17.3968 85.7659 16.4128 86.14 15.4288 86.14ZM34.705 92.251C33.721 92.251 32.737 91.8768 31.9887 91.1234C30.4871 89.6218 30.4871 87.1926 31.9887 85.6909L38.9844 78.6902C40.486 77.1937 42.9204 77.1937 44.422 78.6902C45.9185 80.1918 45.9185 82.6262 44.422 84.1278L37.4212 91.1234C36.673 91.8768 35.689 92.251 34.705 92.251ZM36.0052 110.537C36.7534 111.29 37.7374 111.665 38.7214 111.665C39.7054 111.665 40.6894 111.29 41.4377 110.537L48.4384 103.541C49.9349 102.04 49.9349 99.6055 48.4384 98.1038C46.9368 96.6073 44.5024 96.6073 43.0008 98.1038L36.0052 105.105C34.5036 106.606 34.5036 109.035 36.0052 110.537Z",
    fill: "#4D70B3"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlane);
export default __webpack_public_path__ + "static/media/plane.82ce9d4776ce9ebe00b19107dc91eefd.svg";
export { ForwardRef as ReactComponent };